import { useGate, useStore, useUnit } from 'effector-react'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import {
  $withdrawal,
  $amount,
  withdrawalMounted,
  getWithdrawal,
  $clientPurses,
  $error,
  $errorAmount,
  $success,
  $dividendBalance,
  updateStatusWithdrawal,
  rejectWithdrawal,
  rollbackWithdrawal,
  $statusGateway,
} from './model'

export const useWithdrawal = () => {
  const { pathname } = useLocation()
  const withdrawal = useStore($withdrawal)
  const loading = useStore(getWithdrawal.pending)
  const statusChanging = useStore(updateStatusWithdrawal.pending)
  const rejecting = useStore(rejectWithdrawal.pending)
  const rollingBack = useStore(rollbackWithdrawal.pending)
  const amountVisited = useStore($amount)
  const clientPurses = useStore($clientPurses)
  const error = useStore($error)
  const errorAmount = useStore($errorAmount)
  const success = useStore($success)
  const dividendBalance = useStore($dividendBalance)

  const actionLoading = statusChanging || rejecting || rollingBack

  React.useEffect(() => {
    withdrawalMounted()
  }, [pathname])

  return {
    withdrawal,
    amountVisited,
    loading,
    actionLoading,
    clientPurses,
    error,
    errorAmount,
    success,
    dividendBalance,
  }
}

export const useStatusGateway = () => useUnit($statusGateway)
